import { APP_VERSION } from '@/shared/config/app-version';

export function AppVersionBadge() {
  return (
    <span
      title={APP_VERSION}
      className="mb-0.5 rounded-full bg-muted px-2 py-0.5 text-[11px] leading-none font-medium text-muted-foreground"
    >
      {APP_VERSION}
    </span>
  );
}
